import request from '@/utils/request';
export const defaultIMoqsDiscountData = {
  id: 0,
  enabled: true,
  isNewScheme: false,
  isPieces: false,
  branchId: null,
  rangeId: null,
  discount: 0,
  minimumQuantity: 1,
  minimumCartonQuantity: 0,
  moqId: null,
  dealersRoleId: null,
  categoryId: null,
  subCategoryId: null,
  productId: null,
  productsVariationId: null
};
export const getMoqsDiscounts = params => request({
  url: '/moqs-discounts',
  method: 'get',
  params
});
export const getMoqsDiscountById = id => request({
  url: `/moqs-discounts/${id}`,
  method: 'get'
});
export const updateMoqsDiscount = (id, data) => request({
  url: `/moqs-discounts/${id}`,
  method: 'patch',
  data
});
export const deleteMoqsDiscount = id => request({
  url: `/moqs-discounts/${id}`,
  method: 'delete'
});
export const createMoqsDiscount = data => request({
  url: '/moqs-discounts',
  method: 'post',
  data
});
export const manageMoqsDiscount = data => request({
  url: '/moqs-discounts/manage',
  method: 'post',
  data
});
export const downloadExcel = data => request({
  url: '/moqs-discounts/download-excel',
  method: 'post',
  data,
  responseType: 'blob'
});